import React, {useEffect} from 'react';
import './App.css';
import {requestForNotificationPermission} from "./service/FirebaseMessaging";
import GoogleMaps from "./components/GoogleMaps";
import PushNotification from "./components/PushNotification";
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import {firebaseConfig} from "./utils/FirebaseConfig";

function App() {

    let apiUrl = 'http://localhost:4000';
    if (process.env.NODE_ENV === 'production') {
        if (window.location.hostname.indexOf('local') !== -1) {
            apiUrl = 'https://experientiel-backend.ddev.site';
        } else {
            apiUrl = 'https://experientiel-backend.techniconcept.dev'
        }
    }

    useEffect(() => {
        requestForNotificationPermission()
            .then((permission) => {
                if (permission === 'granted') {
                    console.log("Permission granted for Notification")
                } else {
                    console.error("Permission not granted for Notification")
                }
            })
    }, []);

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    onMessage(messaging, (payload) => {
        const getUserPosition = () => {
            if ('geolocation' in navigator) {
                navigator.geolocation.getCurrentPosition(async (position) => {
                    const { latitude, longitude } = position.coords;

                    try {
                        const token = localStorage.getItem('fcmToken');

                        const response = await fetch(apiUrl + '/send-position', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({token, latitude, longitude}),
                        });

                        const data = await response.json();
                        console.log('Position sent:', data);
                    } catch (error) {
                        console.error('Error sending position:', error);
                    }

                    console.log(`Latitude: ${latitude} °, Longitude: ${longitude} °`);
                }, (error) => {
                    console.error('Erreur de géolocalisation:', error);
                }, {enableHighAccuracy:false,maximumAge:Infinity, timeout:60000});
            }
        };

        if (!payload.data) {
            getUserPosition();
        }

        console.log('Message received. ', payload);
        // Tu peux afficher les notifications dans l'interface utilisateur ici
        displayCustomNotification(payload);
    });

    const displayCustomNotification = (payload: any) => {
        if (!("Notification" in window)) {
            console.log("Ce navigateur ne supporte pas les notifications de bureau");
        } else if (Notification.permission === "granted") {
            new Notification(payload.notification.title, {
                body: payload.notification.body,
                icon: 'https://www.techniconcept.ch/_Resources/Static/Packages/TC.Website/Images/Favicons/apple-touch-icon.png'
            });
        }
    }

    return (
        <div className="App">
            <GoogleMaps/>
            <PushNotification/>
        </div>
    );
}

export default App;
